/* tslint:disable */
/* eslint-disable */
/**
 * pricing API
 * Pricing service
 *
 * The version of the OpenAPI document: 38.848.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SIdHistoricPrice,
  SIdQuote,
  SidPricingOverride,
} from '../models/index';
import {
    SIdHistoricPriceFromJSON,
    SIdHistoricPriceToJSON,
    SIdQuoteFromJSON,
    SIdQuoteToJSON,
    SidPricingOverrideFromJSON,
    SidPricingOverrideToJSON,
} from '../models/index';

export interface ClearOverridesRequest {
    requestBody: Array<string>;
}

export interface GetPriceHistoryRequest {
    sIds: Array<string>;
    from: string;
    until: string;
}

export interface OverrideRequest {
    sidPricingOverride: Array<SidPricingOverride>;
}

export interface PriceRequest {
    requestBody: Array<string>;
}

/**
 * 
 */
export class SIdPricingApi extends runtime.BaseAPI {

    /**
     * Clears manual overrides for the given s_ids for today.
     */
    async clearOverridesRaw(requestParameters: ClearOverridesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling clearOverrides.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("authJwt", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s-id/override`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clears manual overrides for the given s_ids for today.
     */
    async clearOverrides(requestParameters: ClearOverridesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearOverridesRaw(requestParameters, initOverrides);
    }

    /**
     * Force updates all pricing caches to store the latest available information. The caches sometimes do not store any information (e.g outside market hours) - this method can be called so that the price explorer shows the latest available info.
     */
    async forceUpdateSidPricersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("authJwt", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s-id/cache/update`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Force updates all pricing caches to store the latest available information. The caches sometimes do not store any information (e.g outside market hours) - this method can be called so that the price explorer shows the latest available info.
     */
    async forceUpdateSidPricers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.forceUpdateSidPricersRaw(initOverrides);
    }

    /**
     * Returns all cached prices from all pricers. Some of the prices might be last days EoD prices, while others are refreshed each 5 minutes.
     * Get all cached prices.
     */
    async getCachedPricesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SIdQuote>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("authJwt", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s-id/cache/prices`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SIdQuoteFromJSON));
    }

    /**
     * Returns all cached prices from all pricers. Some of the prices might be last days EoD prices, while others are refreshed each 5 minutes.
     * Get all cached prices.
     */
    async getCachedPrices(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SIdQuote>> {
        const response = await this.getCachedPricesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Returns price history for the given dates for the given s_ids. Uses the price_history table of the Data Warehouse.
     */
    async getPriceHistoryRaw(requestParameters: GetPriceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SIdHistoricPrice>>> {
        if (requestParameters.sIds === null || requestParameters.sIds === undefined) {
            throw new runtime.RequiredError('sIds','Required parameter requestParameters.sIds was null or undefined when calling getPriceHistory.');
        }

        if (requestParameters.from === null || requestParameters.from === undefined) {
            throw new runtime.RequiredError('from','Required parameter requestParameters.from was null or undefined when calling getPriceHistory.');
        }

        if (requestParameters.until === null || requestParameters.until === undefined) {
            throw new runtime.RequiredError('until','Required parameter requestParameters.until was null or undefined when calling getPriceHistory.');
        }

        const queryParameters: any = {};

        if (requestParameters.sIds) {
            queryParameters['sIds'] = requestParameters.sIds;
        }

        if (requestParameters.from !== undefined) {
            queryParameters['from'] = requestParameters.from;
        }

        if (requestParameters.until !== undefined) {
            queryParameters['until'] = requestParameters.until;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("authJwt", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s-id/history`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SIdHistoricPriceFromJSON));
    }

    /**
     * Returns price history for the given dates for the given s_ids. Uses the price_history table of the Data Warehouse.
     */
    async getPriceHistory(requestParameters: GetPriceHistoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SIdHistoricPrice>> {
        const response = await this.getPriceHistoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds a manual override for today for a specific asset. This override will be effective until next day 00:00 AM.
     * Override the price of an asset for today.
     */
    async overrideRaw(requestParameters: OverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sidPricingOverride === null || requestParameters.sidPricingOverride === undefined) {
            throw new runtime.RequiredError('sidPricingOverride','Required parameter requestParameters.sidPricingOverride was null or undefined when calling override.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("authJwt", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s-id/override`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.sidPricingOverride?.map(SidPricingOverrideToJSON),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Adds a manual override for today for a specific asset. This override will be effective until next day 00:00 AM.
     * Override the price of an asset for today.
     */
    async override(requestParameters: OverrideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.overrideRaw(requestParameters, initOverrides);
    }

    /**
     * Gets prices for the submitted s_ids from multiple sources.
     * Price the given assets.
     */
    async priceRaw(requestParameters: PriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SIdQuote>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling price.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("authJwt", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/s-id`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SIdQuoteFromJSON));
    }

    /**
     * Gets prices for the submitted s_ids from multiple sources.
     * Price the given assets.
     */
    async price(requestParameters: PriceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SIdQuote>> {
        const response = await this.priceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
